import { breakpoints, colors, media, radius, spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: ${spacing.small} ${spacing.medium};
  border-radius: ${radius.medium};
  background: ${colors.light};
  position: absolute;
  top: ${spacing.medium};
  right: 2rem;
  max-width: calc(100% - 4rem * 2);

  ${media.greaterThan('tablet')`
    left: 50%;
    max-width: ${breakpoints.desktop};
    text-align: center;
    transform: translate(-50%, 0);
    width: fit-content;
  `}
`;
